/**
 * Escrituras citadas en lecciones manuales, guía de nuevos miembros y contenido análogo.
 * Texto según Escrituras en español (Iglesia de Jesucristo de los Santos de los Últimos Días).
 */
import type { Scripture } from './scriptures';

export const manualTrainingScripturesEs: Scripture[] = [
  {
    id: '2-nephi-25-26',
    reference: '2 Nefi 25:26',
    text: 'Y hablamos de Cristo, nos regocijamos en Cristo, predicamos de Cristo, profetizamos de Cristo y escribimos según nuestras profecías, para que nuestros hijos sepan a qué fuente han de acudir para el perdón de sus pecados.',
    verses: [
      {
        verse: 26,
        text: 'Y hablamos de Cristo, nos regocijamos en Cristo, predicamos de Cristo, profetizamos de Cristo y escribimos según nuestras profecías, para que nuestros hijos sepan a qué fuente han de acudir para el perdón de sus pecados.',
      },
    ],
    context: 'Nefi enseña a orientar el corazón y la enseñanza hacia el Salvador.',
  },
  {
    id: '2-nephi-31-17-20',
    reference: '2 Nefi 31:17–20',
    text: 'Por tanto, haced las cosas que os he dicho que he visto que hará vuestro Señor y Redentor; porque por esta razón se me han mostrado, para que sepáis cuál es la puerta por la que debéis entrar. Porque la puerta por la cual debéis entrar es el arrepentimiento y el bautismo en el agua; y entonces viene una remisión de vuestros pecados por fuego y por el Espíritu Santo. Y entonces os halláis en este estrecho y angosto camino que conduce a la vida eterna; sí, habéis entrado por la puerta; habéis obrado de acuerdo con los mandamientos del Padre y del Hijo; y habéis recibido el Espíritu Santo, que da testimonio del Padre y del Hijo, para que se cumpla la promesa hecha por él, que lo recibiríais si entrabais en la senda. Y ahora bien, amados hermanos míos, después de haber entrado en esta estrecha y angosta senda, quisiera preguntar si ya quedó hecho todo. He aquí, os digo que no; porque no habéis llegado hasta aquí sino por la palabra de Cristo, con fe inquebrantable en él, confiando íntegramente en los méritos de aquel que es poderoso para salvar. Por tanto, debéis seguir adelante con firmeza en Cristo, teniendo un fulgor perfecto de esperanza y amor por Dios y por todos los hombres. Por tanto, si marcháis adelante, deleitándoos en la palabra de Cristo, y perseveráis hasta el fin, he aquí, así dice el Padre: Tendréis la vida eterna.',
    verses: [
      {
        verse: 17,
        text: 'Por tanto, haced las cosas que os he dicho que he visto que hará vuestro Señor y Redentor; porque por esta razón se me han mostrado, para que sepáis cuál es la puerta por la que debéis entrar. Porque la puerta por la cual debéis entrar es el arrepentimiento y el bautismo en el agua; y entonces viene una remisión de vuestros pecados por fuego y por el Espíritu Santo.',
      },
      {
        verse: 18,
        text: 'Y entonces os halláis en este estrecho y angosto camino que conduce a la vida eterna; sí, habéis entrado por la puerta; habéis obrado de acuerdo con los mandamientos del Padre y del Hijo; y habéis recibido el Espíritu Santo, que da testimonio del Padre y del Hijo, para que se cumpla la promesa hecha por él, que lo recibiríais si entrabais en la senda.',
      },
      {
        verse: 19,
        text: 'Y ahora bien, amados hermanos míos, después de haber entrado en esta estrecha y angosta senda, quisiera preguntar si ya quedó hecho todo. He aquí, os digo que no; porque no habéis llegado hasta aquí sino por la palabra de Cristo, con fe inquebrantable en él, confiando íntegramente en los méritos de aquel que es poderoso para salvar.',
      },
      {
        verse: 20,
        text: 'Por tanto, debéis seguir adelante con firmeza en Cristo, teniendo un fulgor perfecto de esperanza y amor por Dios y por todos los hombres. Por tanto, si marcháis adelante, deleitándoos en la palabra de Cristo, y perseveráis hasta el fin, he aquí, así dice el Padre: Tendréis la vida eterna.',
      },
    ],
    context: 'Nefi enseña el camino de arrepentimiento, bautismo, Espíritu Santo y perseverancia en Cristo.',
  },
  {
    id: '1-corinthians-15-29',
    reference: '1 Corintios 15:29',
    text: 'De otro modo, ¿qué harán los que se bautizan por los muertos, si en ninguna manera los muertos resucitan? ¿Por qué, pues, se bautizan por ellos?',
    verses: [
      {
        verse: 29,
        text: 'De otro modo, ¿qué harán los que se bautizan por los muertos, si en ninguna manera los muertos resucitan? ¿Por qué, pues, se bautizan por ellos?',
      },
    ],
    context: 'Pablo enseña la realidad de la resurrección en relación con la obra vicaria.',
  },
  {
    id: '1-samuel-3',
    reference: '1 Samuel 3',
    text: 'El niño Samuel ministraba ante Jehová. Jehová llamó a Samuel; Samuel respondió: Háblame, porque tu siervo escucha. Samuel creció, y Jehová estaba con él y no dejó caer ninguna de sus palabras a tierra.',
    context: 'El Señor llama a Samuel; ejemplo de responder con disposición a la voz de Dios.',
  },
  {
    id: '1-timothy-4-12',
    reference: '1 Timoteo 4:12',
    text: 'Ninguno tenga en poco tu juventud; sino sé ejemplo de los fieles, en palabra, en conversación, en caridad, en espíritu, en fe, en limpieza.',
    verses: [
      {
        verse: 12,
        text: 'Ninguno tenga en poco tu juventud; sino sé ejemplo de los fieles, en palabra, en conversación, en caridad, en espíritu, en fe, en limpieza.',
      },
    ],
    context: 'Timoteo recibe el consejo de ser ejemplo de creyente a pesar de su juventud.',
  },
  {
    id: '2-timothy-3-16-17',
    reference: '2 Timoteo 3:16–17',
    text: 'Toda la Escritura es inspirada por Dios, y útil para enseñar, para redargüir, para corregir, para instruir en justicia, a fin de que el hombre de Dios sea perfecto, enteramente preparado para toda buena obra.',
    verses: [
      {
        verse: 16,
        text: 'Toda la Escritura es inspirada por Dios, y útil para enseñar, para redargüir, para corregir, para instruir en justicia,',
      },
      {
        verse: 17,
        text: 'a fin de que el hombre de Dios sea perfecto, enteramente preparado para toda buena obra.',
      },
    ],
    context: 'La Escritura capacita para la enseñanza y la vida recta.',
  },
  {
    id: '3-nephi-17-3',
    reference: '3 Nefi 17:3',
    text: 'Por tanto, id a vuestras casas, y meditad las cosas que os he dicho, y pedid al Padre en mi nombre que podáis entender; y preparad vuestras mentes para mañana, y vendré a vosotros otra vez.',
    verses: [
      {
        verse: 3,
        text: 'Por tanto, id a vuestras casas, y meditad las cosas que os he dicho, y pedid al Padre en mi nombre que podáis entender; y preparad vuestras mentes para mañana, y vendré a vosotros otra vez.',
      },
    ],
    context: 'Jesús invita a meditar, orar y prepararse para Su regreso.',
  },
  {
    id: '3-nephi-18-18-20',
    reference: '3 Nefi 18:18–20',
    text: 'He aquí, en verdad, en verdad os digo que debéis velar y orar siempre, no sea que entréis en tentación; porque Satanás desea poseeros para zarandearos como a trigo. Por tanto, siempre debéis orar al Padre en mi nombre; y cualquier cosa que pidáis al Padre en mi nombre, si es justa, creyendo que recibiréis, he aquí, os será concedida.',
    verses: [
      {
        verse: 18,
        text: 'He aquí, en verdad, en verdad os digo que debéis velar y orar siempre, no sea que entréis en tentación; porque Satanás desea poseeros para zarandearos como a trigo.',
      },
      {
        verse: 19,
        text: 'Por tanto, siempre debéis orar al Padre en mi nombre;',
      },
      {
        verse: 20,
        text: 'y cualquier cosa que pidáis al Padre en mi nombre, si es justa, creyendo que recibiréis, he aquí, os será concedida.',
      },
    ],
    context: 'Cristo enseña a orar en Su nombre y a perseverar en la oración.',
  },
  {
    id: '3-nephi-18-21',
    reference: '3 Nefi 18:21',
    text: 'Orad en vuestras familias al Padre, siempre en mi nombre, para que vuestras esposas y vuestros hijos sean bendecidos.',
    verses: [
      {
        verse: 21,
        text: 'Orad en vuestras familias al Padre, siempre en mi nombre, para que vuestras esposas y vuestros hijos sean bendecidos.',
      },
    ],
    context: 'La oración familiar en el nombre de Cristo.',
  },
  {
    id: '3-nephi-18-28-29',
    reference: '3 Nefi 18:28–29',
    text: 'Y he aquí, este es el mandamiento que yo os doy, que no permitáis que ninguno a sabiendas participe indignamente de mi carne y de mi sangre, cuando las administréis; porque quien come mi carne y bebe mi sangre indignamente, come y bebe condenación para su alma; por tanto, si sabéis que un hombre no es digno de comer y beber de mi carne y de mi sangre, se lo prohibiréis.',
    verses: [
      {
        verse: 28,
        text: 'Y he aquí, este es el mandamiento que yo os doy, que no permitáis que ninguno a sabiendas participe indignamente de mi carne y de mi sangre, cuando las administréis;',
      },
      {
        verse: 29,
        text: 'porque quien come mi carne y bebe mi sangre indignamente, come y bebe condenación para su alma; por tanto, si sabéis que un hombre no es digno de comer y beber de mi carne y de mi sangre, se lo prohibiréis.',
      },
    ],
    context: 'Participar dignamente de la Santa Cena y ministrar con discernimiento.',
  },
  {
    id: 'acts-2-42-47',
    reference: 'Hechos 2:42–47',
    text: 'Y perseveraban en la doctrina de los apóstoles, en la comunión unos con otros, en el partimiento del pan y en las oraciones. Y todo temor era puesto en cada uno, porque muchas maravillas y señales eran hechas por los apóstoles. Y todos los que habían creído estaban juntos, y tenían en común todas las cosas; y vendían sus propiedades y sus bienes, y lo repartían a todos según la necesidad que cada uno tenía. Y perseverando unánimes cada día en el templo, y partiendo el pan en las casas, comían juntos con alegría y sencillez de corazón, alabando a Dios, y teniendo favor con todo el pueblo. Y el Señor añadía cada día a la iglesia los que habían de ser salvos.',
    verses: [
      { verse: 42, text: 'Y perseveraban en la doctrina de los apóstoles, en la comunión unos con otros, en el partimiento del pan y en las oraciones.' },
      { verse: 43, text: 'Y todo temor era puesto en cada uno, porque muchas maravillas y señales eran hechas por los apóstoles.' },
      { verse: 44, text: 'Y todos los que habían creído estaban juntos, y tenían en común todas las cosas;' },
      { verse: 45, text: 'y vendían sus propiedades y sus bienes, y lo repartían a todos según la necesidad que cada uno tenía.' },
      { verse: 46, text: 'Y perseverando unánimes cada día en el templo, y partiendo el pan en las casas, comían juntos con alegría y sencillez de corazón,' },
      { verse: 47, text: 'alabando a Dios, y teniendo favor con todo el pueblo. Y el Señor añadía cada día a la iglesia los que habían de ser salvos.' },
    ],
    context: 'La vida de la Iglesia primitiva: doctrina, comunión, pan y oración.',
  },
  {
    id: 'alma-34-38',
    reference: 'Alma 34:38',
    text: 'que no contendiéis más en contra del Espíritu Santo, sino que lo recibáis, y que toméis sobre vosotros el nombre de Cristo; que os humilléis aun hasta el polvo y adoréis a Dios, en cualquier lugar en que estuviereis, en espíritu y en verdad; y que viváis cada día en acción de gracias por las muchas misericordias y bendiciones que él confiere sobre vosotros.',
    verses: [
      {
        verse: 38,
        text: 'que no contendiéis más en contra del Espíritu Santo, sino que lo recibáis, y que toméis sobre vosotros el nombre de Cristo; que os humilléis aun hasta el polvo y adoréis a Dios, en cualquier lugar en que estuviereis, en espíritu y en verdad; y que viváis cada día en acción de gracias por las muchas misericordias y bendiciones que él confiere sobre vosotros.',
      },
    ],
    context: 'Amulek exhorta a recibir el Espíritu Santo, tomar el nombre de Cristo y dar gracias.',
  },
  {
    id: 'dc-107-head',
    reference: 'Doctrina y Convenios 107',
    text: 'En la iglesia hay dos sacerdocios, a saber, el de Melquisedec y el Aarónico, que incluye el Levítico. La razón por la cual el primero se llama Sacerdocio de Melquisedec es que Melquisedec fue un gran sumo sacerdote.',
    verses: [
      {
        verse: 1,
        text: 'En la iglesia hay dos sacerdocios, a saber, el de Melquisedec y el Aarónico, que incluye el Levítico.',
      },
      {
        verse: 2,
        text: 'La razón por la cual el primero se llama Sacerdocio de Melquisedec es que Melquisedec fue un gran sumo sacerdote.',
      },
    ],
    context: 'Inicio de la revelación sobre los dos sacerdocios en la Iglesia.',
  },
  {
    id: 'dc-107-8-9',
    reference: 'Doctrina y Convenios 107:8–9',
    text: 'El Sacerdocio de Melquisedec posee el derecho de presidir, y tiene poder y autoridad sobre todos los oficios en la iglesia en todas las edades del mundo, para administrar en las cosas espirituales. La presidencia del sumo sacerdocio, según el orden de Melquisedec, tiene el derecho de oficiar en todos los oficios de la iglesia.',
    verses: [
      {
        verse: 8,
        text: 'El Sacerdocio de Melquisedec posee el derecho de presidir, y tiene poder y autoridad sobre todos los oficios en la iglesia en todas las edades del mundo, para administrar en las cosas espirituales.',
      },
      {
        verse: 9,
        text: 'La presidencia del sumo sacerdocio, según el orden de Melquisedec, tiene el derecho de oficiar en todos los oficios de la iglesia.',
      },
    ],
    context: 'Autoridad del Sacerdocio de Melquisedec y de su presidencia.',
  },
  {
    id: 'dc-124-39',
    reference: 'Doctrina y Convenios 124:39',
    text: 'De modo que cuando venga esta casa, un rey y un consejero, el sumo sacerdote y el élder, entre vosotros, podréis crecer hasta convertiros en un reino santo, un dominio y una nación digna de mí.',
    verses: [
      {
        verse: 39,
        text: 'De modo que cuando venga esta casa, un rey y un consejero, el sumo sacerdote y el élder, entre vosotros, podréis crecer hasta convertiros en un reino santo, un dominio y una nación digna de mí.',
      },
    ],
    context: 'Propósito del templo y la preparación del pueblo de Dios.',
  },
  {
    id: 'dc-20-46-59',
    reference: 'Doctrina y Convenios 20:46–59',
    text: 'Deberes del presbítero, maestro y diácono según la organización revelada de la Iglesia.',
    verses: [
      {
        verse: 46,
        text: 'El deber del presbítero es predicar, enseñar, exponer, exhortar, bautizar y administrar la santa cena,',
      },
      {
        verse: 47,
        text: 'y visitar la casa de todos los miembros, y exhortarlos a orar vocalmente, así como en secreto, y a cumplir con todos los deberes familiares.',
      },
      {
        verse: 48,
        text: 'Y también puede ordenar a otros presbíteros, maestros y diáconos.',
      },
      {
        verse: 49,
        text: 'Y ha de hacerse cargo de las reuniones cuando no esté presente ningún élder;',
      },
      {
        verse: 50,
        text: 'mas cuando esté presente un élder, solamente ha de predicar, enseñar, exponer, exhortar y bautizar;',
      },
      {
        verse: 51,
        text: 'y visitar la casa de todos los miembros, exhortándolos a orar vocalmente, así como en secreto, y a cumplir con todos los deberes familiares.',
      },
      {
        verse: 52,
        text: 'En todos estos deberes, el presbítero debe ayudar al élder, si la ocasión lo requiere.',
      },
      {
        verse: 53,
        text: 'El deber del maestro es velar siempre por los miembros de la iglesia, y estar con ellos y fortalecerlos;',
      },
      {
        verse: 54,
        text: 'y cuidar de que no haya iniquidad en la iglesia, ni aspereza entre uno y otro, ni mentiras, ni difamaciones, ni calumnias;',
      },
      {
        verse: 55,
        text: 'y ver que los miembros de la iglesia se reúnan con frecuencia, y también ver que todos los miembros cumplan con sus deberes.',
      },
      {
        verse: 56,
        text: 'Y se hará cargo de las reuniones si está ausente el élder o presbítero,',
      },
      {
        verse: 57,
        text: 'y los diáconos le ayudarán siempre en todos sus deberes en la iglesia, si la ocasión lo requiere.',
      },
      {
        verse: 58,
        text: 'Pero ni los maestros ni los diáconos tienen la autoridad para bautizar, administrar la santa cena, ni imponer las manos;',
      },
      {
        verse: 59,
        text: 'deben, sin embargo, amonestar, exponer, exhortar, enseñar e invitar a todos a venir a Cristo.',
      },
    ],
    context: 'Doctrina y Convenios 20 describe deberes de presbíteros, maestros y diáconos.',
  },
  {
    id: 'dc-84-33-44',
    reference: 'Doctrina y Convenios 84:33–44',
    text: 'Porque quienes son fieles hasta obtener estos dos sacerdocios de los cuales he hablado, y magnifican su llamamiento, son santificados por el Espíritu para la renovación de sus cuerpos. Llegan a ser los hijos de Moisés y de Aarón, y la descendencia de Abraham, y la iglesia y reino, y los elegidos de Dios. Y también todos los que reciben este sacerdocio, a mí me reciben, dice el Señor; porque el que recibe a mis siervos, me recibe a mí; y el que me recibe a mí, recibe a mi Padre; y el que recibe a mi Padre, recibe el reino de mi Padre; por tanto, todo lo que mi Padre tiene le será dado. Y esto va de acuerdo con el juramento y el convenio que corresponden a este sacerdocio. Así que, todos los que reciben el sacerdocio reciben este juramento y convenio de mi Padre, que él no puede quebrantar, ni tampoco puede ser traspasado. Pero el que violare este convenio, después de haberlo recibido, y lo abandonare totalmente, no recibirá perdón de los pecados en este mundo ni en el venidero. Y, ¡ay! de todos aquellos que no obtengan este sacerdocio que habéis recibido, el cual ahora confirmo por mi propia voz desde los cielos sobre vosotros que estáis presentes este día; y aun os he encomendado a las huestes celestiales y a mis ángeles. Y ahora os doy el mandamiento de tener cuidado, en cuanto a vosotros mismos, de estar diligentemente atentos a las palabras de vida eterna. Porque viviréis de toda palabra que sale de la boca de Dios.',
    verses: [
      {
        verse: 33,
        text: 'Porque quienes son fieles hasta obtener estos dos sacerdocios de los cuales he hablado, y magnifican su llamamiento, son santificados por el Espíritu para la renovación de sus cuerpos.',
      },
      {
        verse: 34,
        text: 'Llegan a ser los hijos de Moisés y de Aarón, y la descendencia de Abraham, y la iglesia y reino, y los elegidos de Dios.',
      },
      { verse: 35, text: 'Y también todos los que reciben este sacerdocio, a mí me reciben, dice el Señor;' },
      { verse: 36, text: 'porque el que recibe a mis siervos, me recibe a mí;' },
      { verse: 37, text: 'y el que me recibe a mí, recibe a mi Padre;' },
      {
        verse: 38,
        text: 'y el que recibe a mi Padre, recibe el reino de mi Padre; por tanto, todo lo que mi Padre tiene le será dado.',
      },
      {
        verse: 39,
        text: 'Y esto va de acuerdo con el juramento y el convenio que corresponden a este sacerdocio.',
      },
      {
        verse: 40,
        text: 'Así que, todos los que reciben el sacerdocio reciben este juramento y convenio de mi Padre, que él no puede quebrantar, ni tampoco puede ser traspasado.',
      },
      {
        verse: 41,
        text: 'Pero el que violare este convenio, después de haberlo recibido, y lo abandonare totalmente, no recibirá perdón de los pecados en este mundo ni en el venidero.',
      },
      {
        verse: 42,
        text: 'Y, ¡ay! de todos aquellos que no obtengan este sacerdocio que habéis recibido, el cual ahora confirmo por mi propia voz desde los cielos sobre vosotros que estáis presentes este día; y aun os he encomendado a las huestes celestiales y a mis ángeles.',
      },
      {
        verse: 43,
        text: 'Y ahora os doy el mandamiento de tener cuidado, en cuanto a vosotros mismos, de estar diligentemente atentos a las palabras de vida eterna.',
      },
      { verse: 44, text: 'Porque viviréis de toda palabra que sale de la boca de Dios.' },
    ],
    context: 'Juramento y convenio del sacerdocio: fidelidad, recepción de Cristo y vida por la palabra de Dios.',
  },
  {
    id: 'dc-97-8',
    reference: 'Doctrina y Convenios 97:8',
    text: 'De cierto os digo, que todos los que de entre ellos saben que su corazón es sincero y está quebrantado, y su espíritu es contrito, y están dispuestos a cumplir sus convenios con sacrificio, sí, cualquier sacrificio que yo, el Señor, mandare, estos son aceptados por mí.',
    verses: [
      {
        verse: 8,
        text: 'De cierto os digo, que todos los que de entre ellos saben que su corazón es sincero y está quebrantado, y su espíritu es contrito, y están dispuestos a cumplir sus convenios con sacrificio, sí, cualquier sacrificio que yo, el Señor, mandare, estos son aceptados por mí.',
      },
    ],
    context: 'El Señor acepta a quienes ofrecen corazón sincero y sacrificio en el convenio.',
  },
  {
    id: 'dc-38-30',
    reference: 'Doctrina y Convenios 38:30',
    text: 'Os digo estas cosas a causa de vuestras oraciones; por lo tanto, atesorad sabiduría en vuestro seno, no sea que la maldad de los hombres os revele estas cosas por medio de su iniquidad, de una manera que retumbará en vuestros oídos con una voz más fuerte que la que sacudirá la tierra; mas si estáis preparados, no temeréis.',
    verses: [
      {
        verse: 30,
        text: 'Os digo estas cosas a causa de vuestras oraciones; por lo tanto, atesorad sabiduría en vuestro seno, no sea que la maldad de los hombres os revele estas cosas por medio de su iniquidad, de una manera que retumbará en vuestros oídos con una voz más fuerte que la que sacudirá la tierra; mas si estáis preparados, no temeréis.',
      },
    ],
    context: 'Atesorar sabiduría y prepararse espiritualmente según la palabra del Señor.',
  },
  {
    id: 'dc-42-14',
    reference: 'Doctrina y Convenios 42:14',
    text: 'Y se os dará el Espíritu por la oración de fe; y si no recibís el Espíritu, no enseñaréis.',
    verses: [
      {
        verse: 14,
        text: 'Y se os dará el Espíritu por la oración de fe; y si no recibís el Espíritu, no enseñaréis.',
      },
    ],
    context: 'La enseñanza en la Iglesia debe apoyarse en el Espíritu Santo.',
  },
  {
    id: 'dc-50-13-14',
    reference: 'Doctrina y Convenios 50:13–14',
    text: 'Por tanto, yo, el Señor, os hago esta pregunta: ¿a qué fueron ordenados? A predicar mi evangelio por el Espíritu, aun el Consolador enviado para enseñar la verdad.',
    verses: [
      {
        verse: 13,
        text: 'Por tanto, yo, el Señor, os hago esta pregunta: ¿a qué fueron ordenados?',
      },
      {
        verse: 14,
        text: 'A predicar mi evangelio por el Espíritu, aun el Consolador enviado para enseñar la verdad.',
      },
    ],
    context: 'Predicar el evangelio por el Espíritu, el Consolador enviado para enseñar la verdad.',
  },
  {
    id: 'dc-64-10-11',
    reference: 'Doctrina y Convenios 64:10–11',
    text: 'Yo, el Señor, perdonaré a quien sea mi voluntad perdonar, mas a vosotros os es requerido perdonar a todos los hombres. Y debéis decir en vuestros corazones: Juzgue Dios entre tú y yo, y te premie de acuerdo con tus hechos.',
    verses: [
      {
        verse: 10,
        text: 'Yo, el Señor, perdonaré a quien sea mi voluntad perdonar, mas a vosotros os es requerido perdonar a todos los hombres.',
      },
      {
        verse: 11,
        text: 'Y debéis decir en vuestros corazones: Juzgue Dios entre tú y yo, y te premie de acuerdo con tus hechos.',
      },
    ],
    context: 'Perdón divino y obligación de perdonar a todos.',
  },
  {
    id: 'dc-8-2',
    reference: 'Doctrina y Convenios 8:2',
    text: 'Sí, he aquí, hablaré a tu mente y a tu corazón por medio del Espíritu Santo que vendrá sobre ti y morará en tu corazón.',
    verses: [
      {
        verse: 2,
        text: 'Sí, he aquí, hablaré a tu mente y a tu corazón por medio del Espíritu Santo que vendrá sobre ti y morará en tu corazón.',
      },
    ],
    context: 'Cómo el Espíritu revela verdad en mente y corazón.',
  },
  {
    id: 'dc-88-118',
    reference: 'Doctrina y Convenios 88:118',
    text: 'Y por cuanto no todos tienen fe, buscad diligentemente y enseñaos el uno al otro palabras de sabiduría; sí, buscad palabras de sabiduría de los mejores libros; buscad conocimiento, tanto por el estudio como por la fe.',
    verses: [
      {
        verse: 118,
        text: 'Y por cuanto no todos tienen fe, buscad diligentemente y enseñaos el uno al otro palabras de sabiduría; sí, buscad palabras de sabiduría de los mejores libros; buscad conocimiento, tanto por el estudio como por la fe.',
      },
    ],
    context: 'Estudio, fe y enseñanza mutua en Cristo.',
  },
  {
    id: 'dc-88-119',
    reference: 'Doctrina y Convenios 88:119',
    text: 'Organizaos; preparad todo lo que fuere necesario; y estableced una casa, sí, una casa de oración, una casa de ayuno, una casa de fe, una casa de instrucción, una casa de gloria, una casa de orden, una casa de Dios;',
    verses: [
      {
        verse: 119,
        text: 'Organizaos; preparad todo lo que fuere necesario; y estableced una casa, sí, una casa de oración, una casa de ayuno, una casa de fe, una casa de instrucción, una casa de gloria, una casa de orden, una casa de Dios;',
      },
    ],
    context: 'Orden y santidad en el hogar y en la Iglesia.',
  },
  {
    id: 'dc-88-77',
    reference: 'Doctrina y Convenios 88:77',
    text: 'Y os mando que os enseñéis el uno al otro la doctrina del reino.',
    verses: [
      {
        verse: 77,
        text: 'Y os mando que os enseñéis el uno al otro la doctrina del reino.',
      },
    ],
    context: 'Enseñanza mutua de la doctrina del reino.',
  },
  {
    id: 'john-13-34-35',
    reference: 'Juan 13:34–35',
    text: 'Un mandamiento nuevo os doy: Que os améis unos a otros; como yo os he amado, que también os améis unos a otros. En esto conocerán todos que sois mis discípulos, si tuviereis amor los unos con los otros.',
    verses: [
      {
        verse: 34,
        text: 'Un mandamiento nuevo os doy: Que os améis unos a otros; como yo os he amado, que también os améis unos a otros.',
      },
      {
        verse: 35,
        text: 'En esto conocerán todos que sois mis discípulos, si tuviereis amor los unos con los otros.',
      },
    ],
    context: 'El mandamiento del Salvador de amarnos unos a otros.',
  },
  {
    id: 'john-17-3',
    reference: 'Juan 17:3',
    text: 'Y esta es la vida eterna: que te conozcan a ti, el único Dios verdadero, y a Jesucristo, a quien has enviado.',
    verses: [
      {
        verse: 3,
        text: 'Y esta es la vida eterna: que te conozcan a ti, el único Dios verdadero, y a Jesucristo, a quien has enviado.',
      },
    ],
    context: 'La vida eterna es conocer al Padre y a Jesucristo.',
  },
  {
    id: 'luke-22-26-27',
    reference: 'Lucas 22:26–27',
    text: 'Mas no así vosotros, sino el mayor entre vosotros, sea como el menor; y el que dirige, como el que sirve. Porque, ¿cuál es mayor, el que se sienta a la mesa, o el que sirve? ¿No es el que se sienta a la mesa? Mas yo entre vosotros como el que sirve.',
    verses: [
      {
        verse: 26,
        text: 'Mas no así vosotros, sino el mayor entre vosotros, sea como el menor; y el que dirige, como el que sirve.',
      },
      {
        verse: 27,
        text: 'Porque, ¿cuál es mayor, el que se sienta a la mesa, o el que sirve? ¿No es el que se sienta a la mesa? Mas yo entre vosotros como el que sirve.',
      },
    ],
    context: 'Jesucristo enseña el liderazgo como servicio.',
  },
  {
    id: 'matthew-19-14',
    reference: 'Mateo 19:14',
    text: 'Jesús entonces dijo: Dejad a los niños venir a mí, y no se lo impidáis; porque de los tales es el reino de los cielos.',
    verses: [
      {
        verse: 14,
        text: 'Jesús entonces dijo: Dejad a los niños venir a mí, y no se lo impidáis; porque de los tales es el reino de los cielos.',
      },
    ],
    context: 'Jesús bendice a los niños y acoge su fe.',
  },
  {
    id: 'moroni-10-32',
    reference: 'Moroni 10:32',
    text: 'Venid a Cristo, y sed perfeccionados en él, y negados enteramente de toda impiedad; y si negáis enteramente de toda impiedad, entonces son sus ángeles los que os rodean, para sosteneros.',
    verses: [
      {
        verse: 32,
        text: 'Venid a Cristo, y sed perfeccionados en él, y negados enteramente de toda impiedad; y si negáis enteramente de toda impiedad, entonces son sus ángeles los que os rodean, para sosteneros.',
      },
    ],
    context: 'Invitación final de Moroni a venir a Cristo.',
  },
  {
    id: 'moroni-7-45',
    reference: 'Moroni 7:45',
    text: 'Y la caridad es sufrida, y es benigna, y la caridad no tiene envidia, y la caridad no es jactanciosa, ni se envanece; no hace nada indebido, no busca lo suyo, no se irrita fácilmente, no piensa el mal;',
    verses: [
      {
        verse: 45,
        text: 'Y la caridad es sufrida, y es benigna, y la caridad no tiene envidia, y la caridad no es jactanciosa, ni se envanece; no hace nada indebido, no busca lo suyo, no se irrita fácilmente, no piensa el mal;',
      },
    ],
    context: 'Mormón describe los atributos de la verdadera caridad.',
  },
  {
    id: 'moroni-8-26',
    reference: 'Moroni 8:26',
    text: 'y la remisión de los pecados trae la mansedumbre y la humildad de corazón; y por motivo de la mansedumbre y la humildad de corazón viene la visitación del Espíritu Santo, el cual Consolador llena de esperanza y de amor perfecto, amor que perdura por la diligencia en la oración, hasta que venga el fin, cuando todos los santos morarán con Dios.',
    verses: [
      {
        verse: 26,
        text: 'y la remisión de los pecados trae la mansedumbre y la humildad de corazón; y por motivo de la mansedumbre y la humildad de corazón viene la visitación del Espíritu Santo, el cual Consolador llena de esperanza y de amor perfecto, amor que perdura por la diligencia en la oración, hasta que venga el fin, cuando todos los santos morarán con Dios.',
      },
    ],
    context: 'Mormón enseña que la remisión de pecados abre paso al Espíritu Santo y al amor duradero.',
  },
  {
    id: 'mosiah-18-21',
    reference: 'Mosíah 18:21',
    text: 'Y mandó que no hubiese contención unos con otros, sino que mirasen hacia adelante con un ojo, teniendo una fe y un bautismo, teniendo sus corazones entrelazados en unidad y en amor unos hacia otros.',
    verses: [
      {
        verse: 21,
        text: 'Y mandó que no hubiese contención unos con otros, sino que mirasen hacia adelante con un ojo, teniendo una fe y un bautismo, teniendo sus corazones entrelazados en unidad y en amor unos hacia otros.',
      },
    ],
    context: 'Alma manda unidad, una fe y amor entre los bautizados en Mormon.',
  },
  {
    id: 'mosiah-5-chapter',
    reference: 'Mosíah 5',
    text: 'El pueblo hace convenio de llamarse el pueblo de Dios y de poner por obra Su palabra. El rey Benjamín exhorta a recordar el convenio y a ser fieles hasta el fin.',
    context: 'Capítulo del Libro de Mormón sobre el convenio del pueblo tras la enseñanza de Benjamín.',
  },
  {
    id: 'proverbs-15-22',
    reference: 'Proverbios 15:22',
    text: 'Los pensamientos son frustrados donde no hay consejo; mas en la multitud de consejeros se confirman.',
    verses: [
      {
        verse: 22,
        text: 'Los pensamientos son frustrados donde no hay consejo; mas en la multitud de consejeros se confirman.',
      },
    ],
    context: 'La sabiduría de buscar consejo.',
  },
  {
    id: 'proverbs-31-20',
    reference: 'Proverbios 31:20',
    text: 'Extiende sus manos al menesteroso, y alarga sus manos al pobre.',
    verses: [
      {
        verse: 20,
        text: 'Extiende sus manos al menesteroso, y alarga sus manos al pobre.',
      },
    ],
    context: 'La mujer virtuosa sirve con compasión.',
  },
  {
    id: 'psalms-24-3-4',
    reference: 'Salmos 24:3–4',
    text: '¿Quién subirá al monte de Jehová? ¿Y quién estará en su lugar santo? El limpio de manos y puro de corazón, que no ha elevado su alma a cosas vanas, ni jurado con engaño.',
    verses: [
      {
        verse: 3,
        text: '¿Quién subirá al monte de Jehová? ¿Y quién estará en su lugar santo?',
      },
      {
        verse: 4,
        text: 'El limpio de manos y puro de corazón, que no ha elevado su alma a cosas vanas, ni jurado con engaño.',
      },
    ],
    context: 'Quién puede acercarse a la presencia de Dios.',
  },
];
